var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25779 5.99902L5.70394 1.55287C5.79753 1.45929 5.84753 1.36538 5.85394 1.27115C5.86036 1.17691 5.81036 1.07659 5.70394 0.970172C5.59753 0.863755 5.50041 0.810547 5.4126 0.810547C5.32478 0.810547 5.22484 0.86658 5.11279 0.978647L0.582794 5.50865C0.512277 5.58581 0.459386 5.66408 0.424119 5.74345C0.388869 5.8228 0.371245 5.90966 0.371245 6.00402C0.371245 6.09839 0.388869 6.18525 0.424119 6.2646C0.459386 6.34396 0.512277 6.4189 0.582794 6.4894L5.11279 11.0194C5.21201 11.1186 5.30457 11.1673 5.39047 11.1654C5.47637 11.1635 5.57253 11.1093 5.67894 11.0029C5.78536 10.8965 5.83857 10.7993 5.83857 10.7115C5.83857 10.6237 5.78536 10.5266 5.67894 10.4202L1.25779 5.99902Z",
    fill: "#00838F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.874a2078ba4f41ddfa496d80e4393c88.svg";
export { ForwardRef as ReactComponent };